import { authGuard, permissionGuard } from '@abp/ng.core';
import { Routes } from '@angular/router';
import { ORDER_INBOX_CONFIGURATIONS } from './main/order-inbox/models/order-inbox-configuration';
import { NEW_ORDER_CONFIGURATIONS } from './main/new-orders/models/new-order-configuration';
import { SCMPermissions } from './shared/AppConsts';

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./main/order-inbox/order-inbox-landing/order-inbox-landing').then(c => c.OrderInboxLandingComponent),
    canActivate: [authGuard],
  },
  {
    path: 'orders/supervisor',
    loadComponent: () => import('./main/order-inbox/order-inbox/order-inbox').then(c => c.OrderInboxComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SCMPermissions.Orders.Supervisor,
      inboxConfig: ORDER_INBOX_CONFIGURATIONS.supervisor,
    },
  },
  {
    path: 'orders/contractor',
    loadComponent: () => import('./main/order-inbox/order-inbox/order-inbox').then(c => c.OrderInboxComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SCMPermissions.Orders.Contractor,
      inboxConfig: ORDER_INBOX_CONFIGURATIONS.contractor,
    },
  },
  {
    path: 'orders/silviculture',
    loadComponent: () => import('./main/order-inbox/order-inbox/order-inbox').then(c => c.OrderInboxComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SCMPermissions.Orders.Silviculture,
      inboxConfig: ORDER_INBOX_CONFIGURATIONS.silviculture,
    },
  },
  {
    path: 'orders/warehouse-manager',
    loadComponent: () => import('./main/order-inbox/order-inbox/order-inbox').then(c => c.OrderInboxComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SCMPermissions.Orders.WarehouseManager,
      inboxConfig: ORDER_INBOX_CONFIGURATIONS.warehouseManager,
    },
  },
  {
    path: 'purchase-order/:id',
    pathMatch: 'full',
    loadComponent: () => import('./main/details/purchase-order-details/purchase-order-details').then(c => c.PurchaseOrderDetails),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'order/:id',
    pathMatch: 'full',
    loadComponent: () => import('./main/details/order-details/order-details').then(c => c.OrderDetails),
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: 'StockConsumableManagement.Orders'
    }
  },  
  {
    path: 'new/contractor',
    pathMatch: 'full',
    loadComponent: () => import('./main/new-orders/new-order/new-order').then(c => c.NewOrder),
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SCMPermissions.Orders.Contractor,
      newOrderConfig: NEW_ORDER_CONFIGURATIONS.contractor,
    },
  },
  {
    path: 'new/silviculture',
    pathMatch: 'full',
    loadComponent: () => import('./main/new-orders/new-order/new-order').then(c => c.NewOrder),
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SCMPermissions.Orders.Silviculture,
      newOrderConfig: NEW_ORDER_CONFIGURATIONS.silviculture,
    },
  },
  {
    path: 'confirm/:id',
    pathMatch: 'full',
    loadComponent: () => import('./main/confirm-order/confirm-order').then(c => c.ConfirmOrder),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'synchronization',
    loadComponent: () => import('./main/synchronization/synchronization').then(c => c.SynchronizationComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SCMPermissions.Sync,
    },
  },
  {
    path: 'account',
    loadChildren: () => import('@volo/abp.ng.account/public').then(c => c.createRoutes()),
  },
  {
    path: 'identity',
    loadChildren: () => import('@volo/abp.ng.identity').then(c => c.createRoutes()),
  },
  {
    path: 'language-management',
    loadChildren: () => import('@volo/abp.ng.language-management').then(c => c.createRoutes()),
  },
  {
    path: 'saas',
    loadChildren: () => import('@volo/abp.ng.saas').then(c => c.createRoutes()),
  },
  {
    path: 'audit-logs',
    loadChildren: () => import('@volo/abp.ng.audit-logging').then(c => c.createRoutes()),
  },
  {
    path: 'openiddict',
    loadChildren: () => import('@volo/abp.ng.openiddictpro').then(c => c.createRoutes()),
  },
  {
    path: 'text-template-management',
    loadChildren: () => import('@volo/abp.ng.text-template-management').then(c => c.createRoutes()),
  },
  {
    path: 'setting-management',
    loadChildren: () => import('@abp/ng.setting-management').then(c => c.createRoutes()),
  },
];
